import script from "./ModificaRilevazione.vue?vue&type=script&setup=true&lang=js"
export * from "./ModificaRilevazione.vue?vue&type=script&setup=true&lang=js"

import "./ModificaRilevazione.vue?vue&type=style&index=0&id=787f0cd6&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-787f0cd6"]])

export default __exports__